export function abbreviateMiddleNames(fullName: string): string {
  // Split the name into words, remove leading/trailing spaces and split into words
  const nameParts = fullName.trim().split(" ").filter(Boolean); // Filter removes empty parts

  // If there's only one or two parts, return the name as is
  if (nameParts.length <= 2) {
    return nameParts.join(" ");
  }

  // Extract the first and last name
  const firstName = nameParts[0];
  const lastName = nameParts[nameParts.length - 1];

  // Abbreviate all middle names
  const middleNames = nameParts.slice(1, -1);
  const abbreviatedMiddleNames = middleNames.length
    ? middleNames.map(name => `${name[0].toLocaleUpperCase()}.`).join(" ")
    : ""; // Avoid "undefined."

  // Combine the first name, abbreviated middle names, and last name
  const finalName = `${firstName} ${abbreviatedMiddleNames} ${lastName}`;

  return finalName;
}
